/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useState } from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import cookies from 'js-cookie'
import jwt from 'jsonwebtoken'

import Grid from '@material-ui/core/Grid'
import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Alert from '@material-ui/lab/Alert'

import MySiteLayoutDrawerMenu from 'components/molecules/MySiteLayoutDrawerMenu'
import LayoutHeaderMenuContainer from 'containers/LayoutHeaderMenuContainer'

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  footer: {
    width: '100%',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  contentWrap: {
    flexGrow: 1,
    boxSizing: 'border-box',
    marginLeft: 0,
    backgroundColor: theme.palette.background.default,
    width: `100%`,
    minHeight: '100vh'
  },
  content: {
    margin: '0 auto',
    padding: theme.spacing(2)
  },
  toolbar: theme.mixins.toolbar,
  logo: {
    maxHeight: 24,
    display: 'block'
  }
})
export const useProps = {}
const MySiteLayout = ({ classes, proxy, ...props }) => {
  const {
    width,
    children,
    menus = [],
    favoriteMenu = [],
    routeParams = {}
  } = props
  const { onClickFavoriteIcon } = proxy
  const { title, drawer = true } = routeParams
  const ahid = jwt.decode(cookies.get('AHID'))
  const { appName, logoUrl, apphomeConfig = {} } = ahid || {}
  const defaultDrawerOpen = drawer && isWidthUp('md', width)
  const [drawerOpen, setDrawerOpen] = useState(undefined)
  const sideMenu = apphomeConfig?.menuItemsVisibility?.sideMenu
  const headerMenu = apphomeConfig?.menuItemsVisibility?.headerMenu
  return (
    <div className={classes.root}>
      {headerMenu && (
        <AppBar color="inherit" className={classes.appBar} elevation={1}>
          <Toolbar>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <Grid container spacing={1} alignItems="center" wrap="nowrap">
                  {sideMenu && !isWidthUp('md', width) && (
                    <IconButton
                      edge="start"
                      onClick={() =>
                        setDrawerOpen(
                          !(drawerOpen !== undefined
                            ? drawerOpen
                            : defaultDrawerOpen)
                        )
                      }
                    >
                      <MenuIcon />
                    </IconButton>
                  )}
                  <Grid item>
                    <img
                      src={logoUrl}
                      alt="appLogo"
                      title="logo"
                      className={classes.logo}
                    />
                  </Grid>
                  {isWidthUp('md', width) && (
                    <Grid item>
                      <Typography variant="body2" color="textSecondary">
                        {appName}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs="auto">
                    <Typography variant="body2">{title}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <LayoutHeaderMenuContainer />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      )}
      {sideMenu && (
        <MySiteLayoutDrawerMenu
          open={drawerOpen !== undefined ? drawerOpen : defaultDrawerOpen}
          visibleHeader={headerMenu}
          setDrawerOpen={setDrawerOpen}
          menus={menus}
          favoriteMenu={favoriteMenu}
          onClickFavoriteIcon={onClickFavoriteIcon}
        />
      )}
      <main className={classes.contentWrap}>
        {headerMenu && <div className={classes.toolbar} />}
        {ahid?.stage === 'DEVELOP' && (
          <Box pb={2}>
            <Alert elevation={1} variant="filled" severity="error">
              마이사이트 미리보기 중입니다.
            </Alert>
          </Box>
        )}
        <div className={classes.content}>{children}</div>
        <div className={classes.footer}>
          <Typography
            display="block"
            align="center"
            variant="caption"
            color="textSecondary"
          >
            POWERED BY SOLAPI, INC.
          </Typography>
        </div>
      </main>
    </div>
  )
}

MySiteLayout.defaultProps = setDefaultProps(useProps)
MySiteLayout.propTypes = setPropTypes(useProps)
export default withStyles(styles)(withWidth()(MySiteLayout))
